export const MAINTENANCE_NOTICE_HEADING = "重要なお知らせ";
